export const getTruncatedText = (text: string, containerWidth: number): string => {
    if (!text) return '';
    
    // Create a temporary element to measure text
    const temp = document.createElement('div');
    temp.style.cssText = `
        position: absolute;
        visibility: hidden;
        width: ${containerWidth}px;
        font-size: 0.875rem;
        line-height: 1.5rem;
    `;
    document.body.appendChild(temp);
    
    temp.textContent = text;
    
    // Line height: 1.5rem = 24px (assuming 16px root font size)
    const lineHeight = 24;
    const maxHeight = lineHeight * 2;
    
    if (temp.offsetHeight <= maxHeight) {
        document.body.removeChild(temp);
        return text;
    }
    
    // Binary search for truncation point
    let left = 0;
    let right = text.length;
    let result = text;
    
    // Reserve space for "... Read more" (approximately 100-120px)
    const readMoreSpace = 110;
    
    while (left < right) {
        const mid = Math.floor((left + right + 1) / 2);
        const testText = text.substring(0, mid);
        temp.textContent = testText + '... ';
        
        // Only apply padding if we're already on the second line
        if (temp.offsetHeight > lineHeight) {
            temp.style.paddingRight = `${readMoreSpace}px`;
        } else {
            temp.style.paddingRight = '0px';
        }
        
        if (temp.offsetHeight <= maxHeight) {
            result = testText;
            left = mid;
        } else {
            right = mid - 1;
        }
    }
    
    document.body.removeChild(temp);
    return result.trim();
};